<template>
    <div>
        <navigation-bar Close/>
        <div class="transfer main">
            <category-content class="text-left pt-0">
                <ul>
                    <li class="date">{{endAtDate}}</li>
                    <li><h2 class="brand overflow-omitted">{{commodityName}}</h2></li>
                </ul>
            </category-content>
            <div>
                <category-header title="轉贈對象">
                    <div slot="more" class="buttons">
                        <el-button type="text" @click="gotoCamera" >
                            <img src="@/assets/images/qrcode.svg" alt="掃碼">
                        </el-button>
                        <!--<el-button type="text">
                            <img src="@/assets/images/scan2.svg" alt="">
                        </el-button>-->
                    </div>
                </category-header>
                <div class="border-input d-flex">
                    <div v-if="destName" class="dest-img">
                        <el-image :src="destImg" fit="cover"/>
                    </div>
                    <el-input class="border-input border-0 m-0 flex-1 red"
                              placeholder="請輸入對方會員ID或電話號碼"
                              readonly v-model="destName"
                              @click.native="showTargetInputDialog('轉贈對象')" />
                </div>
                <category-header title="轉贈數量">
                    <span slot="more" class="text">
                      可轉贈點數<span>{{maxAvailableCount}}</span>點
                    </span>
                </category-header>

                <number-controller :params="numberControllerParams" @triggerEvent="numberControllerEvent"/>

                <category-header title="備註欄" class="mb-2"/>
                <el-input
                        class="border-input"
                        placeholder="此備註欄位僅您本人可以查看"
                        type="textarea"
                        :rows="4"
                        v-model="remarks"></el-input>
                <category-header title="留言給對方" class="mb-2"/>
                <el-input
                        class="border-input"
                        placeholder="請輸入文字內容"
                        type="textarea"
                        :rows="4"
                        v-model="message"></el-input>
            </div>
            <div slot="footer" class="footer-button">
                <el-button @click="goBack" class="cancel" round>取消</el-button>
                <el-button type="primary" @click="onConfirmBtnClick" round>送出</el-button>
            </div>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true" />
        <target-input-dialog :value="isShowTargetInputDialog"
                             :outerContent="dialogMsg"
                             :isCancel="true"
                             :appendToBody="isWeb"
                             @result="onTargetInputDialogResult" />
        <target-confirm-dialog :value="isShowTargetConfirmDialog"
                               :icon="tmpImg"
                               :outerContent="dialogMsg"
                               :name="tmpName"
                               :isCancel="true"
                               :appendToBody="isWeb"
                               @result="onTargetConfirmDialogResult" />
        <comm-dialog :value="isShowDialog"
                     :outerContent="dialogMsg"
                     :mainContent="dialogMsgMain"
                     :icon="icons"
                     :isCancel="false"
                     :appendToBody="isWeb"
                     @result="onDialogResult" />
    </div>
</template>

<script>

    import {checkPhone} from "@/util/validators";

    const goToList = 1;

    import CategoryContent from '@/components/category/Content.vue'
    import CategoryHeader from '@/components/category/Header.vue';
    import CommDialog from '@/components/CommDialog.vue';
    import TargetInputDialog from "./components/TargetInputDialog";
    import TargetConfirmDialog from "./components/TargetConfirmDialog";
    import NumberController from "@/components/NumberController";


    export default {
        name: "TransferLoyaltyCard",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            CategoryContent,
            CategoryHeader,
            CommDialog,
            TargetInputDialog,
            TargetConfirmDialog,
            NumberController,
        },
        data() {
            return {
                id: this.isWeb? parseInt(this.dataTokenWeb.id || this.$store.state.giftBox.id) : parseInt(this.$route.params.id || this.$store.state.giftBox.id),    //該集點卡在個人資料表中的 id
                loyaltyCardListId: this.isWeb? parseInt(this.dataTokenWeb.loyaltyCardListId || this.$store.state.giftBox.loyaltyCardListId) :parseInt(this.$route.params.loyaltyCardListId || this.$store.state.giftBox.loyaltyCardListId),    //該集點卡在個人資料表中的 id
                isShowDialog: false,
                //彈框大標
                dialogMsg: '',
                //彈框小標
                dialogMsgMain: '',
                //彈框圖示
                icons: require('@/assets/images/dialog_question.svg'),
                destToken: '',       //要轉贈的對象的 token
                transAmount: 1,      //轉贈點數
                maxAvailableCount: 1,      //最大可轉贈的點數
                commodityName: '',   //物品名稱
                endAtDate: '',     //到期日, yyyy-MM-dd
                convertEnd: '',     //轉贈結束時間
                remarks: '',    //備註
                message: '',    //留言
                isLoading: false,     //是否顯示載入動畫
                dialogResult: 0,
                destName: '',       //轉贈對象的名稱 (顯示用)
                destPhone: '',      //轉贈對象的手機號碼 或 userCode
                destImg: '',        //轉贈對象的頭像
                tmpName: '',        //暫存轉贈對象的名稱 (顯示用)
                tmpPhone: '',       //暫存轉贈對象的手機號碼 或 userCode
                tmpImg: '',         //暫存轉贈對象的頭像
                isShowTargetInputDialog: false,
                isShowTargetConfirmDialog: false,

                numberControllerParams: {
                  default: 1,
                  min: 1,
                  max: 1,
                },
            }
        },
        created() {
            //讀取掃描結果
            let scanResult = sessionStorage.getItem('cameraResult');
            if (scanResult !== null && scanResult !== '') {
                //讀取完要清除，要再取得結果就要重新掃描
                sessionStorage.setItem('cameraResult', '');
                this.onScanResult(scanResult);
            }
        },
        mounted() {
          if(this.id === undefined || this.id === null || this.id === 0) {
            this.$router.back();
          } else {
            this.setupData();
          }
        },
        methods: {

          /** 開啓相機 */
          gotoCamera() {
            this.$store.commit('setGiftBox', {
              id: this.id,
              loyaltyCardListId: this.loyaltyCardListId,
            });
            this.$router.push({name: `ScanCode`});
          },
          /** 接收掃描結果 */
          onScanResult(value) {
            if (/vcard/g.test(value.toLowerCase())) {
              this.showDialog("請用本 app 的個人條碼來掃描");
            } else {
              // this.destToken = value;
              //解析 token
              let decodeToken = this.$crypto.decryptText(value);
              let decodeAry = decodeToken.split(';');
              if (decodeAry !== undefined && decodeAry.length > 0) {
                let userId = decodeAry[0];
                this.doTargetConfirm(userId, '', '');
              } else {
                this.showDialog("掃描錯誤，請確認是否爲本 app 產生的 QRcode");
              }
            }
          },

          /** 顯示 dialog */
          showDialog(msg) {
            this.dialogMsg = msg;
            this.isShowDialog = true;
          },

          /** dialog事件 返回 */
          onDialogResult() {
            this.isShowDialog = false;
            if (this.dialogResult === goToList) {
              this.dialogResult = 0;
                if(!this.isWeb){
                    this.$router.push({name: 'Gift', params: {activeCategory: 'loyaltyCard', activeTab: 'use'}});
                }else {
                    //單店網頁版用
                    this.$emit('close', true);
                }
            }
          },

          /** 確定轉贈 */
          onConfirmBtnClick() {
            if (this.destPhone === "" && this.destToken === "") {
              this.showDialog('請輸入轉贈對象');
            } else if (isNaN(this.transAmount) || this.transAmount <= 0 || this.transAmount > this.maxAvailableCount) {
              this.showDialog(`轉贈點數錯誤`);
            } else if (this.destPhone !== '') {
              //送出，帶入 user輸入的電話
              this.callGiftLoyaltyCardApi(
                  '',
                  this.destPhone,
              );
            } else {
              //送出，帶入 user token
              this.callGiftLoyaltyCardApi(
                  this.destToken,
                  '',
              );
            }
          },

          /** 轉移點數 */
          callGiftLoyaltyCardApi(destToken, destUserCode) {
            this.isLoading = true;

            this.$http.fetchWithAuth`GiftLoyaltyCard${{
              id: this.id,                    //集點卡 id
              loyaltyCardListId: this.loyaltyCardListId,
              amount: Number(this.transAmount),     //轉移點數
              userToken: destToken,     //轉讓對象token
              toUserCode: destUserCode,     //轉讓對象電話或 user code
              myselfNote: this.remarks,     //備註
              toUserNote: this.message,     //留言
            }}
                 ${json => {
              if (json.status) {
                this.showDialog('轉贈點數成功');
                this.dialogMsgMain =`剩餘點數<span class="red">${json.amount}</span>點`
                this.icons= require('@/assets/images/dialog_ticket.svg')
                this.dialogResult = goToList;
              } else {
                this.showDialog('抱歉：' + json.message);
              }
              this.isLoading = false;
            }}`;
          },

          /** 取得集點卡詳情 */
          setupData() {
            this.$http.fetchWithAuth`GetMySelfLoyaltyCardInfoById${{
              id: this.id,
            }}
                 ${json => {
              if (json.data !== null && json.data !== '') {
                this.commodityName = json.data.name;
                this.endAtDate = json.data.activityEnd;
                this.convertEnd = json.data.convertEnd;

                this.maxAvailableCount = json.data.amount;
                this.numberControllerParams.max = this.maxAvailableCount;
                if (this.maxAvailableCount === 0) {
                  this.showDialog('目前沒有可以轉贈的點數');
                }
              }
            }
            }}`;
          },

          /** 顯示 輸入轉贈對象 dialog */
          showTargetInputDialog: function (msg) {
            this.dialogMsg = msg;
            this.isShowTargetInputDialog = true;
          },
          /** 輸入轉贈對象dialog事件 返回 */
          onTargetInputDialogResult: function (result, type, target) {
            this.isShowTargetInputDialog = false;
            if (result) {
              if (checkPhone(target)) {
                this.doTargetConfirm('', target, '');

              } else {
                this.doTargetConfirm('', '', target);
              }
            }
          },
          /** 顯示 確認轉贈對象 dialog */
          showTargetConfirmDialog: function () {
            this.dialogMsg = '確認對象';
            this.isShowTargetConfirmDialog = true;
          },

          /** 確認轉贈對象dialog事件 返回 */
          onTargetConfirmDialogResult: function (result, type) {
            this.isShowTargetConfirmDialog = false;
            if (result) {
              this.destName = this.tmpName;
              this.destPhone = this.tmpPhone;
              this.destImg = this.tmpImg;
            }
          },
          /** 確認轉贈對象 */
          doTargetConfirm: function (userId, userPhone, userCode) {
            if(userId === '' && userPhone === '' && userCode === '') {
              this.showDialog('請輸入對方會員ID或電話號碼');
              return false
            }

            this.callGetOtherUserInfoApi(userId, userPhone, userCode)
                .then(this.showTargetConfirmDialog)
                .catch((error) => {
                  this.isLoading = false;
                  this.showDialog(error);
                  // self.$store.commit(mutationTypes.SHOW_TOAST, error);
                });
          },

          /** 查轉贈對象資訊，任一條件有就尋找，最好只輸入其中一項資料 */
          callGetOtherUserInfoApi: function (userId = '', userPhone = '', userCode = '') {
              this.isLoading = true;

              let self = this;
              return new Promise(function (resolve, reject) {
                  self.$http.fetchWithAuthEncrypt`GetUserInfoData${{
                      userId: Number(userId),    //查詢對象的 userId
                      userCode: userCode,     //查詢對象的代號
                      phone: userPhone,     //查詢對象的電話
                  }} ${json => {

                      self.isLoading = false;
                      if (json.status) {
                          try {
                              json.data = self.$crypto.decryptObjectText(json.data)
                          } catch (e) {
                             //
                          }

                          if (json.data.isExist) {
                              self.tmpName = json.data.name;
                              self.tmpPhone = json.data.userCode;
                              self.tmpImg = json.data.picture;       //'https://file.oinapp.com/' +
                              resolve();
                          } else {
                              reject('沒有此會員');
                              self.dialogMsgMain = '請確認號碼輸入是否正確'
                          }
                      } else {
                          reject('沒有轉贈對象的資料');
                      }
                  }}`;
              });
          },
          numberControllerEvent(obj) {
            let self = this;
            let event = obj.event;

            if (event === "returnNumber") {
              self.transAmount = obj.number
            } else if (event === "clickDisabledButton") {
              if(obj.operate === "dec") {
                this.showDialog('點數不可少於 1 點');
              }
            }
          },

            goBack(){
                if(!this.isWeb){
                    this.$router.back()
                }else {
                    //單店網頁版用
                    this.$emit('close',false);
                }
            }
        }
    }
</script>

<style lang="less" scoped src="../../less/transfer.less"/>